<template>
  <div class="page">
    <div class="container">
      <notifications-list></notifications-list>
    </div>
  </div>
</template>

<script>
import NotificationsList from "@/components/NotificationsList"

export default {
  name: "NotificationsPage",
  components: { NotificationsList },
}
</script>
